import { mergeClassName } from "../../utils/helpers";
import { Itablelayout } from "./type";

export const tableHeadStyle = (layout: Itablelayout) => {
  let template;
  switch (layout) {
    case "app":
      template =
        " sticky top-0 z-[1] border-b bg-white py-2.5 text-sm leading-6 text-[#5B5B5B] font-manrope  font-extrabold px-4 ";
      break;
    case "comp":
      template =
        " sticky top-0 z-[1] border-b bg-white py-2.5 px-9 text-sm leading-6 text-gray-330 first:pl-9 last:pr-9";
      break;
    case "wal-set":
      template =
        "pb-3 px-9 text-base leading-none text-black font-medium capitalize first:pl-9 last:pr-9";
      break;

    default:
      template =
        "sticky top-0 z-[1]  bg-white pb-0.5 px-4 text-sm leading-6 text-gray-330 first:pl-4.5 last:pr-4.5";
      break;
  }
  return template;
};

export const tableDataStyle = (
  layout: Itablelayout,
  status?: string,
  active?: boolean
) => {
  let template;
  switch (layout) {
    case "comp":
      template = mergeClassName(
        "flex-1 cursor-pointer border-y pt-4 pb-5 px-9 text-1417 font-medium text-gray-320 first:rounded-l-xl first:border-l first:pl-9 last:rounded-r-xl last:border-r last:pr-9",
        status?.toLowerCase() === "approved"
          ? "border-green-50 bg-green-60"
          : "border-gray-310"
      );
      break;
    case "wal-set":
      template = mergeClassName(
        "flex-1 cursor-pointer border-y pt-4 pb-5 px-9 text-1417 font-medium text-green-40 first:rounded-l-xl first:border-l first:pl-9 last:rounded-r-xl last:border-r last:pr-9",
        active ? "border-green-50 bg-green-30 " : ""
      );
      break;

    default:
      template =
        " cursor-pointer border-y border-gray-310 px-4 text-1417 font-medium text-gray-320 first:rounded-l-xl first:border-l first:pl-4.5 last:rounded-r-xl last:border-r last:pr-4.5 group";
      break;
  }
  return template;
};
